import { apPutCrmCustomer } from '@/services/CrmService';
import { getCrmCustomersStatistic, getCustomersList } from '@/services/CustomerManagementService';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const getCustomerStatistic = createAsyncThunk('crmCustomers/data/getCustomerStatistic', async () => {
  const response = await getCrmCustomersStatistic();
  return response.data;
});

export const getCustomers = createAsyncThunk('crmCustomers/data/getCustomers', async (params) => {
  const response = await getCustomersList();
  return response.data;
});

export const putCustomer = createAsyncThunk('crmCustomers/data/putCustomer', async (data) => {
  const response = await apPutCrmCustomer(data);
  return response.data;
});

export const initialTableData = {
  total: 0,
  pageIndex: 1,
  pageSize: 10,
  query: '',
  sort: {
    order: '',
    key: '',
  },
};

export const initialFilterData = {
  status: '',
};

const dataSlice = createSlice({
  name: 'crmCustomers/data',
  initialState: {
    loading: false,
    customerList: [],
    statisticData: {},
    tableData: initialTableData,
    filterData: initialFilterData,
  },
  reducers: {
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setCustomerList: (state, action) => {
      state.customerList = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
  },
  extraReducers: {
    [getCustomers.fulfilled]: (state, action) => {
      state.customerList = action.payload;
      state.tableData.total = 1;
      state.loading = false;
    },
    [getCustomers.pending]: (state) => {
      state.loading = true;
    },
    [getCustomerStatistic.pending]: (state) => {
      state.statisticLoading = true;
    },
    [getCustomerStatistic.fulfilled]: (state, action) => {
      state.statisticData = action.payload;
      state.statisticLoading = false;
    },
  },
});

export const { setTableData, setCustomerList, setFilterData } = dataSlice.actions;

export default dataSlice.reducer;
